import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Label,
    Spinner,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { withNamespaces } from "react-i18next";

const ApplicableReasonModal = ({ t, isOpen, toggle, onSubmit, isSubmiting, controlName }) => {
    const handleValidSubmit = (_event, values) => {
        onSubmit && onSubmit({ reason: values.reason })
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle}>
            <AvForm onValidSubmit={handleValidSubmit}>
                <ModalHeader toggle={toggle}>
                    {t("Reason for marking \"{{controlName}}\" as Not Applicable", {
                        controlName: controlName
                    })}
                </ModalHeader>
                <ModalBody>
                    <Label for="reason">
                        {t('Reason')}
                    </Label>
                    <AvField
                        type="textarea"
                        name="reason"
                        id="reason"
                        required
                        validate={{
                            required: { value: true, errorMessage: "Please provide a reason" },
                            minLength: { value: 5, errorMessage: "Reason must be at least 5 characters" },
                        }}
                    />
                </ModalBody>
                <ModalFooter>
                    <Button 
                        color="secondary" 
                        onClick={toggle} 
                        disabled={isSubmiting}
                    >
                        {t('Cancel')}
                    </Button>
                    <Button 
                        color="danger" 
                        type="submit" 
                        disabled={isSubmiting}
                    >
                        {isSubmiting ? <Spinner color="white" size="sm" className="me-2" /> : null}
                        {t('Submit')}
                    </Button>
                </ModalFooter>
            </AvForm>
        </Modal>
    );
}

export default withNamespaces()(
    ApplicableReasonModal
);